<template>
  <div class="login_session" v-if="cart.member == null" :style="$root.bodyfit_style">

    <div class="login_session_area">

        <div class="login_session_back_area display_responsive">
            <div class="back_btn_div" @click="$root.goBack()">
                <div class="back_btn"></div>
            </div>
        </div>

        <div class="login_session_title">{{label['guestlogin_page_header_text']}}</div>

        <div class="login_session_div">
            <div class="login_session_inner_area">

                <div class="login_form_area">
                    <form style="width:100%;" @submit="(e)=>{e.preventDefault();guestLogin();}">

                        <div class="login_form_row">
                            <div class="login_form_title">{{label['guestlogin_login_form_loginid_text']}}</div>
                            <div class="login_form_input">
                                <!--
                                <select class="form-control select" id="login_countryCode" v-model="login_countryCode" >
                                    <option v-for="(c, index) in $root.countryCodeList" :value="c">
                                        +{{c}}
                                    </option>
                                </select>
                                <input type="text" class="form-control selectinput" id="login_id" v-model="login_id" maxlength="100" :placeholder="label['guestlogin_login_form_loginid_text']" />
                                -->
                                <input type="text" class="form-control" id="login_id" v-model="login_id" maxlength="100" :placeholder="label['guestlogin_login_form_loginid_text']" />
                            </div>
                        </div>

                        <div class="login_form_row">
                            <div class="login_form_title">{{label['guestlogin_login_form_login_password_text']}}</div>
                            <div class="login_form_input">
                                <input type="password" class="form-control" id="login_pass" v-model="login_pass" maxlength="50" :placeholder="label['guestlogin_login_form_login_password_text']" />
                            </div>
                            <div class="login_form_highlight cursor" @click="$root.CommonAppDownloadPage()">{{label['sidemenu_not_member_register_text']}}</div>
                        </div>

                        <div class="login_form_row">
                            <button type="submit" class="login_form_submit_btn">{{label['guestlogin_login_form_login_btn_text']}}</button>
                        </div>

                    </form>
                </div>

                <div class="login_form_area" v-if="info.allowGuestMode">

                    <div class="login_form_row no_margin">
                        <span class="normal_text">{{label['guestlogin_page_text_or']}}</span>
                    </div>
                    <div class="login_form_row">
                        <div class="login_form_submit_btn guest_btn" @click="continueGuestMode()">{{label['guestlogin_page_text_continue_as_guest']}}</div>
                    </div>

                </div>

                <div class="login_form_area social_login" v-if="googleLoginisInit">

                    <div class="social_login_btn_div">
                        <!--<div class="g-signin2" data-onsuccess="GoogleLoginOnSignIn"></div>-->
                        <div class="g_id_signin" data-type="standard" data-size="large" data-theme="outline" data-text="sign_in_with" data-shape="pill" data-logo_alignment="left"></div>
                    </div>

                    <div class="social_login_btn_div">
                        <div id="appleid-signin" data-color="black" data-border="true" data-type="sign in"></div>
                    </div>

                </div>


            </div>
        </div>

    </div>


    <div v-if="googleLoginisInit" 
        id="g_id_onload" 
        :data-client_id="$root.googleLoginID" 
        data-ux_mode="redirect" 
        :data-login_uri="info.currentDomain + '/api/Order/GoogleLoginRedirect'" 
        :data-state="'{\'redirect\':\''+$root.page_after_login+'\'}'" 
    ></div>

  </div>
</template>

<script>
    export default {
        data() {
            return {
                login_countryCode:"852",
                login_id: "",
                login_pass: "",
                googleLoginisInit: false,
                appleLoginisInit: false,
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            cart() {
                return this.$root.cart;
            },
            EnableReceiveNews() {
                return this.info.receiveNews || false;
            },
        },
        components: {},
        created() {

            this.$root.CreateGoogleLogin();
            this.$root.CreateAppleLogin();
            this.googleLoginisInit = agLoginObj.googleLoginisInit;
            this.appleLoginisInit = agLoginObj.appleLoginisInit;
            if (agLoginObj.appleLoginisInit) {
                AppleLoginClientIDInit(this.$root.appleLoginID, this.info.currentDomain +'/api/Order/AppleLoginRedirect', '{\'redirect\':\'' + this.$root.page_after_login + '\'}');
            }

            this.info.loading = false;
            //this.info.loading = true;
            this.$root.getCurrentPathName();

            if (!this.info.allowGuestMode) {
                if (this.cart.member != null) {
                    this.$router.push(this.$root.page_after_login);
                    this.$root.page_after_login = "/";
                }
                else {
                    //this.$root.LoginBtnClickGuestLoginPage(); // redirect to third party login page
                }
            }
            else {
                //this.continueGuestMode();
            }

            /*
            // check have brand and shop or not
            this.$root.initSelectBrand();

            // check have cart items or not
            if (this.cart.items.length <= 0) {
                this.$router.replace("/");
            }
            */
        },
        methods: {
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },            
            remarkFormYesNoClick(this_form, this_index) {
                this_form.setValue = (this_form.setValue == "y") ? "n" : "y";
                this.$set(this.remarkForm, this_index, this_form);
            },

            guestLogin() {
                var app = this;
                var check_form = true;

                if (app.login_id.replace(/ /g, '') == "" || app.login_pass.replace(/ /g, '') == "") {
                    check_form = false;
                }

                if (!check_form) {
                    return;
                }
                //app.sendMemberLogin(app.login_id, app.login_pass);
                var login_type = "phone";
                var loginID = "+" + app.login_countryCode + "-" + app.login_id;
                if (ValidateEmail(app.login_id)) {
                    login_type = "email";
                    loginID = app.login_id;
                }
                app.sendMemberLogin(login_type, loginID, app.login_pass);
            },
            sendMemberLogin(login_type, login_id, login_pass) {
                var app = this;
                this.info.loading = true;
                this.$root
                    .wsPost(
                        this.info.wsUrl + "/Order/Login",
                        this.lang,
                        JSON.stringify({ data: { token: this.cart.token, login_type: login_type,  username: login_id, password: login_pass } }),
                        (data) => {
                            this.$root.serverTimeDiff = moment(data.serverTime).toDate().getTime() - new Date().getTime();
                            //console.log("serverTimeDiff", this.$root.serverTimeDiff);
                            console.log("sendMemberLogin", data);
							
                            if ((data.aToken != undefined && data.aToken != null && data.aToken != '') && (data.rToken != undefined && data.rToken != null && data.rToken != ''))
                                UpdateARToken(app.info.order_temp_info.order_device, data.aToken, data.rToken);
							
                            if (data.status == 0) {
                                this.cart.token = data.token;
                                $.extend(this.cart, data.cart);
                                this.cart.updateCart();
                                this.cart.saveCart();

                                // update order contact info
                                if (this.info.order_temp_info.order_address_type == "search" && this.cart.member != null) {
                                    this.$root.FillMemberInfoToOrderContactInfo();
                                    this.$root.setOrderTempInfoData();
                                }

                                this.$root.GetMemberAddressList();
                                this.$root.GetMemberPreferShopList();

                                this.info.loading = false;
                                this.$router.push(this.$root.page_after_login);
                                this.$root.page_after_login = "/";
                            } else {
                                //this.$root.alert(data.message);
                                this.$root.alert('common_text_login_fail');
                                this.info.loading = false;
                            }
                        }
                    )
                    .always(() => {
                        //this.info.loading = false;
                    })
                    .fail(() => {
                        //this.$root.alert("Fail!");
                        this.$root.alert("common_fail_message");
                        this.info.loading = false;
                    });
            },

            continueGuestMode() {
                this.$router.push("/checkout");
            },

        },        
    };
</script>
